import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoachingVideoApi } from '../coaching-video.api';
import { ApiHttpResponse, Coaching } from '@kinomap-dev/ng-ui-lib';

@Injectable({
  providedIn: 'root',
  useClass: CoachingVideoApi,
})
export abstract class ICoachingVideoApi {
  abstract getCoachingVideos(
    page: number,
    limit: number,
    userId?: number
  ): Observable<ApiHttpResponse<Coaching[]>>;
}
